import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 17 16'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M6.729 3.363a.9.9 0 0 1 1.273 0l4 4a.9.9 0 0 1 0 1.273l-4 4a.9.9 0 1 1-1.273-1.273l3.363-3.364L6.73 4.636a.9.9 0 0 1 0-1.273'
      clipRule='evenodd'
    />
  </svg>
)
export default SvgComponent
